import React, { useEffect } from 'react';

const Toast = ({ message, type = 'success', isVisible, onClose, duration = 5000 }) => {
  useEffect(() => {
    if (isVisible && duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose]);

  if (!isVisible) return null;

  const getToastStyles = () => {
    const baseStyles = {
      position: 'fixed',
      top: '20px',
      right: '20px',
      padding: '1rem 1.5rem',
      borderRadius: '8px',
      color: 'white',
      fontWeight: '500',
      fontSize: '0.95rem',
      zIndex: 9999,
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
      transform: 'translateX(100%)',
      animation: 'slideIn 0.3s ease forwards',
      maxWidth: '400px',
      wordWrap: 'break-word'
    };

    switch (type) {
      case 'success':
        return {
          ...baseStyles,
          backgroundColor: '#28a745',
          borderLeft: '4px solid #1e7e34'
        };
      case 'error':
        return {
          ...baseStyles,
          backgroundColor: '#dc3545',
          borderLeft: '4px solid #c82333'
        };
      case 'warning':
        return {
          ...baseStyles,
          backgroundColor: '#ffc107',
          color: '#212529',
          borderLeft: '4px solid #e0a800'
        };
      case 'info':
        return {
          ...baseStyles,
          backgroundColor: '#17a2b8',
          borderLeft: '4px solid #138496'
        };
      default:
        return baseStyles;
    }
  };

  return (
    <>
      <style>
        {`
          @keyframes slideIn {
            from {
              transform: translateX(100%);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }
          
          @keyframes slideOut {
            from {
              transform: translateX(0);
              opacity: 1;
            }
            to {
              transform: translateX(100%);
              opacity: 0;
            }
          }
        `}
      </style>
      <div style={getToastStyles()}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <span>{message}</span>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              color: 'inherit',
              fontSize: '1.2rem',
              cursor: 'pointer',
              marginLeft: '1rem',
              padding: '0',
              opacity: '0.7',
              transition: 'opacity 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.opacity = '1'}
            onMouseLeave={(e) => e.target.style.opacity = '0.7'}
          >
            ×
          </button>
        </div>
      </div>
    </>
  );
};

export default Toast;
